import React, { useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'react-redux';
import SideBarListStyles from '../../../styles/SideBarListStyle';
import FloatButton from '../../sidebar/FloatButton';
import ContestAddNewPopup from './ContestAddNewPopup';
import ShowProgress from '../../ui/Backdrop';

const SidebarListContest = ({ filterArray, fetchData, handleListItemClick }) => {
  const classes = SideBarListStyles();
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = useState(false);
  const selectedId = useSelector((state) => state.contestData.selectedId);
  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    if (myRefs[selectedId]) {
      myRefs[selectedId].current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedId, myRefs]);

  const toggleAddNewPopup = () => setIsAddNewPopupOpen((prev) => !prev);

  const renderListItem = (data) => {
    const isSelected = selectedId === data.id;

    return (
      <div key={data.id} className={isSelected ? classes.highlightItem : ''}>
        <ListItem
          button
          selected={isSelected}
          className={classes.listStyling}
          onClick={() => handleListItemClick(data.id)}
          ref={myRefs[data.id]}
        >
          <ListItemText
            primary={<p className={isSelected ? classes.listTextSelected : classes.listTextNonSelected}>{data.name}</p>}
            secondary={
              <div className={isSelected ? classes.listSubTextSelected : classes.listSubTextNonSelected}>
                <div className={classes.listSubTextJustify}>
                  <div>{`${data.dealershipCount || 0} Dealerships`}</div>
                  <div className={!data.enabled ? classes.secondaryTextRed : null}>
                    {`${data.enabled ? 'Active' : 'Inactive'}`}
                  </div>
                </div>
              </div>
            }
          />
        </ListItem>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray.map(renderListItem)}
      </List>
      <FloatButton
        fabs={[{ color: 'primary', className: classes.fab, icon: <AddIcon />, label: 'Add' }]}
        value={0}
        mainTabID={19}
        onAddNewContest={toggleAddNewPopup}
      />
      {isAddNewPopupOpen && (
        <ContestAddNewPopup
          handleListItemClick={handleListItemClick}
          close={toggleAddNewPopup}
          add
          refreshData={fetchData}
        />
      )}
      <ShowProgress />
    </div>
  );
};

export default SidebarListContest;
